import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import { OverviewAlertsChart } from './overviewAlertsChart';
import { useWorldRoutes } from '../../../routes/parts/allWorldRoutes';
import { useTranslation } from '@lib/useTypedTranslation';
import { getCategories } from './common';

import './style.css';
import { IBatteriesWithCount, ISmartBatteryAlertCount } from '../../../services/shared/battery/batteryCentricService';
import Card from '@components/card/card';
import { AlertsOverview } from './alertsOverview';

interface IProps {
  data: IBatteriesWithCount,
  batteryAlerts?: ISmartBatteryAlertCount,
  isLoading?: boolean
}

export function BatteryAlertsContainer(props: IProps) {
  const routes = useWorldRoutes();
  const linkToBatteries = routes.batteryEssentials.battery;
  const ns = 'translation';
  const ns1 = 'batteryOverview';
  const { t } = useTranslation([ns, ns1]);

  const batteryMessage = <div className="battery-alerts-message">
    <div className="message-header">{t("BATTERY_OVERVIEW_BATTERIES_TITLE", { ns: ns1 })}</div>
    <Link to={linkToBatteries} className="message-link">{t('VIEW_ALL', { ns })}</Link>
  </div>;

  return (
    <Card noPadding={true} className="battery-alerts-container">
      <OverviewAlertsChart
        link={linkToBatteries}
        data={props?.data}
        message={batteryMessage}
        categories={getCategories(linkToBatteries)}
        isLoading={props.isLoading}
      />
      <AlertsOverview alerts={props.batteryAlerts} />
    </Card>
  );
}
